import { connect } from 'react-redux'
import { pauseNewsTicker, resumeNewsTicker } from 'redux/actions'
import NewsTickerSmall from 'pages/dashboard/NewsTickerSmall'

const mapStateToProps = (state) => ({
  paused: state.newsTicker.paused,
  deviceType: state.layout.deviceType
})

const mapDispatchToProps = dispatch => ({
  pauseNewsTicker: () => dispatch(pauseNewsTicker()),
  resumeNewsTicker: () => dispatch(resumeNewsTicker())
})

export default connect(mapStateToProps, mapDispatchToProps)(NewsTickerSmall)
